import { default as Api } from '../services/Api'
const locale = document.documentElement.lang
export default {
  data() {
    return {
      load: false,
    }
  },
  methods: {
    async receiveInfo(email=window.user_email, withoutValidation) {
      console.log(email)
      return new Promise(async (resolve, reject) => {
        let pr = arg => {
          return new Promise((res, rej) => {
            res(arg)
            rej( new Error('...'))
          }).then(after => {
            resolve(after)
          })
        }
        if (!withoutValidation) {
          let result = (await this.$validator.validateAll())
          if (!result) return
        }
        this.load = true
        let data = {
          email: email
        }
        try {
          await Api().post(`/${locale}/send/calendar/`, data)
            
          this.load = false
          this.$emit('close')
          this.$validator.reset()
          let message = {
            message: {
              header: window.trans.message_header,
              text: window.trans.message_text
            }
          }
          this.successModal(message, pr)
              
        } catch (e) {
          reject(e)
          this.load = false
          this.$emit('close')
        
        }
        
      })

    },
    successModal(message, promise) {
      this.$modal.show(
        () => import('./MessageModal'), {
        data: message,
        promise: promise
      }, {
        height: 'auto',
        minWidth: 300,
        maxWidth: 370,
        adaptive: true
      })
    },
    openLogin() {
      this.$modal.show(
        () => import('./Login'), {
        sendInfo: true,
      }, {
        height: 'auto',
        minWidth: 300,
        maxWidth: 370,
        adaptive: true
      }, {
        'closed': e => this.load = window.isSend
      })

    }
  }
}




// WEBPACK FOOTER //
// ./src/js/shared/components/getInfoMixin.js